// Shared summary-section pieces for bank-account plan rows. Each parent row
// component (withdrawal destination, contribute source) owns its own
// PlanRow/PlanAccordionShell, validation key, and expanded body, and composes
// these inside summaryChildren/summaryTrailing.
import React from 'react';
import {Box, Chip, Typography} from '@mui/material';
import {BankAccountValidationDisplay} from '../../../../components/Common/BankAccountValidationDisplay';
import {PlanSelector} from './PlanSelector';
import {BuilderBankAccount} from '../../../../schema-types/BuilderBankAccount';
import {getBankAccountDisplayName} from './bankAccountHelpers';

interface BankAccountRowSummaryProps {
  bankAccount: BuilderBankAccount;
  isSelected: boolean;
  handleChange: () => void;
  // Whose account it is — the employer's name on an employer row.
  ownerName?: string | null;
}

export const BankAccountRowSummary: React.FC<BankAccountRowSummaryProps> = ({
  bankAccount,
  isSelected,
  handleChange,
  ownerName,
}) => (
  <>
    <PlanSelector
      mode="single"
      id={bankAccount.id}
      isSelected={isSelected}
      handleChange={handleChange}
    />
    <Box display="flex" flexDirection="row" alignItems="center">
      <Typography variant="body1" sx={{fontWeight: 600}}>
        {getBankAccountDisplayName(bankAccount)}
      </Typography>
      {ownerName && (
        <Typography variant="body2" color="text.secondary" sx={{ml: 1}}>
          {ownerName}
        </Typography>
      )}
    </Box>
  </>
);

export const BankAccountRowStatus: React.FC<{
  bankAccount: BuilderBankAccount;
  ownershipLabel?: string;
}> = ({bankAccount, ownershipLabel}) => (
  <>
    {ownershipLabel && (
      <Box pl={1} display="flex" flexWrap="wrap" alignContent="center">
        <Chip label={ownershipLabel} size="small" variant="outlined" />
      </Box>
    )}
    <Box pl={1} display="flex" flexWrap="wrap" alignContent="center">
      <BankAccountValidationDisplay isValidated={bankAccount.isAccountValidated} />
    </Box>
  </>
);
